import { AgsAnimateBehaviour } from "./ags-animate-behaviour";

export class AgsAlternateAnimateBehaviour extends AgsAnimateBehaviour {
    protected startAnimation(): void {
        this.animation.gotoAndPlay(Math.floor(this.animation.totalFrames * 0.25));
    }
}
